<!--
 * @Descripttion: 字段超链接设置
 * @Author: zenghua.wang
 * @Date: 2021-05-07 14:18:05
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-11 11:19:34
-->
<template>
  <el-form
    style="margin: 20px 0"
    ref="reportLink"
    size="small"
    :model="form"
    label-width="120px"
    label-suffix=":"
  >
    <el-form-item label="添加链接">
      <el-switch
        v-model="form.isLink"
        :active-color="theme.active"
        :inactive-color="theme.inactive"
      >
      </el-switch>
    </el-form-item>

    <template v-if="form.isLink">
      <el-form-item label="链接到">
        <el-radio-group
          v-model="form.urlType"
          size="mini"
        >
          <el-radio-button
            v-for="(item, index) in options.typeList"
            :key="index"
            :label="item.value"
          >{{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="链接地址">
        <el-input
          placeholder="请输入"
          style="width: 600px"
          v-model="form.urlPath"
        >
        </el-input>
        <div class="xa-form-tips">备注：链接地址的参数请通过下面的参数增加</div>
      </el-form-item>

      <el-form-item label="参数">
        <el-button
          size="small"
          icon="el-icon-plus"
          @click="addParam"
        >增加</el-button>
        <el-table
          :data="form.urlParams"
          border
          size="small"
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="参数名">
            <template slot-scope="scope">
              <el-input
                size="small"
                v-model="scope.row.name"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="参数值 (备注: 若没有可供选择的字段，可以手动输入)">
            <template slot-scope="scope">
              <el-select
                style="width:100%"
                v-model="scope.row.key"
                clearable
                filterable
                allow-create
                default-first-option
                :popper-append-to-body="false"
                placeholder="请选择参数"
                @change="setParam($event, scope.row)"
              >
                <el-option
                  v-for="feild in feilds"
                  :key="feild.value"
                  :label="feild.label"
                  :disabled="feild.disabled"
                  :value="feild.label"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="deleteParam(scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import { theme } from '@/dragComponents/model/default.js'
import { isEmpty } from '@/dragComponents/utils'

export default {
  name: 'report-link',
  props: ['form', 'data', 'feilds'],
  data() {
    return {
      theme: theme,
      options: {
        typeList: [
          {
            label: '外部地址',
            value: 'outer'
          },
          {
            label: '内部组件',
            value: 'inner'
          }
        ]
      }
    }
  },
  methods: {
    // 添加参数
    addParam() {
      this.form.urlParams = this.form.urlParams.filter((item) => {
        return item.name || item.key || item.val
      })
      this.form.urlParams.push({
        name: '',
        key: '',
        val: ''
      })
    },
    // 删除参数
    deleteParam(index) {
      this.form.urlParams.splice(index, 1)
    },
    setParam(e, row) {
      if (isEmpty(e)) return
      let label = isEmpty(e.label) ? e : e.label
      if (isEmpty(e.label)) {
        this.$nextTick(() => {
          row.key = label
        })
      } else {
        row.key = label
      }
    }
  }
}
</script>
